import { Text } from "../text/Text";

import "./Entity.css";

import type { ReactNode } from "react";

export interface EntityProps {
  artwork?: string;
  postTitle?: ReactNode;
  title: string;
}

export function Entity({ artwork, postTitle, title }: EntityProps) {
  return (
    <div className="Entity">
      {artwork && <img className="Entity__artwork" src={artwork} alt={title} />}

      <Text
        className="Entity__title"
        weight="semibold"
        lineHeight="tight"
        size="md"
      >
        {title}
      </Text>

      {postTitle && (
        <Text className="Entity__postTitle" preset="pretitle">
          {postTitle}
        </Text>
      )}
    </div>
  );
}
